const fixTimeZone = (tz) => {
  const fixedTZ = tz === 'HST' ? 'HT' : tz;
  return fixedTZ;
};

export default fixTimeZone;
